import { useState } from "react";
import { Button } from "../buttons/Button";

interface FileInputProps {
    allowedExtensions: string[];
    currentFile: File | string | null | undefined;
    onChange: (file: File | null) => void;
    label?: string;
}

export const FileInput = ({
    allowedExtensions,
    currentFile,
    onChange,
    label = "קובץ",
}: FileInputProps) => {
    const [file, setFile] = useState<File | null>(null);

    const selectedFile = file || currentFile;

    const selectedFileName =
        selectedFile instanceof File
            ? selectedFile.name
            : selectedFile
            ? decodeURIComponent(
                  selectedFile.split("/").pop()?.split("?")[0] || ""
              )
            : "";

    const selectedFileLink =
        selectedFile instanceof File
            ? URL.createObjectURL(selectedFile)
            : selectedFile;

    return (
        <div className="w-full flex flex-col gap-1 items-center justify-between py-2 file-input">
            <div
                className={`input-file-name ${
                    selectedFileLink ? "cursor-pointer" : ""
                }`}
                onClick={
                    selectedFileLink
                        ? () => window.open(selectedFileLink, "_blank")
                        : undefined
                }
            >
                {selectedFile ? selectedFileName : "טרם נבחר קובץ"}
            </div>
            <div className="relative w-full flex justify-center">
                <input
                    type="file"
                    accept={allowedExtensions
                        .map((ext) => (ext.startsWith(".") ? ext : `.${ext}`))
                        .join(",")}
                    onChange={(e) => {
                        const file = e.target.files?.[0] || null;
                        setFile(file);
                        onChange(file);
                    }}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                />
                <div className="w-[170px]">
                    <Button variant="secondary">
                        {file || currentFile ? "החלפת" : "בחירת"} {label}
                    </Button>
                </div>
            </div>
        </div>
    );
};
